
<div class="sequence-creator">

  <!-- GIORNI -->
  <section class="creator-section">
    <div class="section-heading">
      <span class="section-number">1</span>
      <div>
        <h4>Giorni di reperibilità</h4>
        <p>Seleziona i giorni della settimana da includere.</p>
      </div>
    </div>

    <div class="days-selector">
      <p-selectButton
        [multiple]="true"
        [options]="[0,1,2,3,4,5,6]"
        (onChange)="frequency = sequencePeriod.days.length"
        [(ngModel)]="sequencePeriod.days"
      >
        <ng-template let-item pTemplate>
          <span>{{ days[item] }}</span>
        </ng-template>
      </p-selectButton>
    </div>

    <div
      class="frequency-row"
      *ngIf="sequencePeriod.days.length > 0"
    >
      <span>Ogni</span>

      <p-inputNumber
        *ngIf="sequencePeriod.days.length > 1"
        [min]="1"
        [max]="sequencePeriod.days.length"
        [(ngModel)]="frequency"
      ></p-inputNumber>

      <span>giorn{{ frequency > 1 ? 'i' : 'o' }}</span>
    </div>
  </section>

  <!-- ORARI -->
  <section class="creator-section">
    <div class="section-heading">
      <span class="section-number">2</span>
      <div>
        <h4>Fasce orarie</h4>
        <p>Definisci gli orari di inizio e fine del servizio.</p>
      </div>
    </div>

    <div class="time-list">
      <ng-container *ngFor="let time of sequencePeriod.times; index as index">
        <div class="time-row">
          <div class="time-field">
            <label>Dalle ore</label>
            <p-inputMask
              mask="99:99"
              [(ngModel)]="time.startTime"
              placeholder="Orario inizio"
            ></p-inputMask>
          </div>

          <div class="time-separator">
            <i class="pi pi-arrow-right"></i>
          </div>

          <div class="time-field">
            <label>Alle ore</label>
            <p-inputMask
              mask="99:99"
              [(ngModel)]="time.endTime"
              placeholder="Orario fine"
            ></p-inputMask>
          </div>

          <div class="time-actions">
            <p-button
              icon="pi pi-plus"
              styleClass="p-button-outlined"
              pTooltip="Aggiungi fascia oraria"
              (onClick)="createNewTime(index)"
            ></p-button>

            <p-button
              *ngIf="index !== 0"
              icon="pi pi-times"
              severity="danger"
              styleClass="p-button-outlined"
              pTooltip="Rimuovi fascia oraria"
              (onClick)="sequencePeriod.times.splice(index, 1)"
            ></p-button>
          </div>
        </div>
      </ng-container>
    </div>
  </section>

  <!-- PERIODO DI RIFERIMENTO -->
  <section class="creator-section">
    <div class="section-heading">
      <span class="section-number">3</span>
      <div>
        <h4>Periodo di riferimento</h4>
        <p>Indica le date di inizio e fine della programmazione.</p>
      </div>
    </div>

    <div class="date-row">
      <div class="date-field">
        <label for="sequence-start-date">Data inizio</label>
        <p-calendar
          inputId="sequence-start-date"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [showButtonBar]="true"
          [minDate]="minDate"
          [maxDate]="rangeDates[1] || maxSelectableDate"
          [ngModel]="rangeDates[0]"
          (ngModelChange)="setStartDate($event)"
          placeholder="gg/mm/aaaa"
          [appendTo]="'body'"
        ></p-calendar>
      </div>

      <div class="date-separator" aria-hidden="true">
        <i class="pi pi-arrow-right"></i>
      </div>

      <div class="date-field">
        <label for="sequence-end-date">Data fine</label>
        <p-calendar
          inputId="sequence-end-date"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [showButtonBar]="true"
          [minDate]="rangeDates[0] || minDate"
          [ngModel]="rangeDates[1]"
          (ngModelChange)="setEndDate($event)"
          placeholder="gg/mm/aaaa"
          [appendTo]="'body'"
        ></p-calendar>
      </div>
    </div>
  </section>

  <!-- DELEGATI -->
  <section class="creator-section">
    <div class="section-heading">
      <span class="section-number">4</span>
      <div>
        <h4>Delegati reperibili</h4>
        <p>
          Sposta i delegati dall'elenco generale a quello
          dei reperibili.
        </p>
      </div>
    </div>

    <div class="delegates-container">
      <p-pickList
        [style]="{'width':'100%'}"
        [source]="delegates"
        [target]="targetDelegates"
        sourceHeader="Tutti i delegati"
        targetHeader="Delegati reperibili"
        [dragdrop]="true"
        [responsive]="true"
      >
        <ng-template let-delegate pTemplate="item">
          <div class="delegate-item">
            <i class="pi pi-user"></i>
            <span>
              {{ delegate.user.name }} {{ delegate.user.lastName }}
            </span>
          </div>
        </ng-template>
      </p-pickList>
    </div>
  </section>

  <!-- CONFERMA -->
  <div class="creator-actions">
    <p-button
      label="Genera turni"
      icon="pi pi-check"
      (onClick)="generateSequence()"
    ></p-button>
  </div>

</div>
